import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ProcedureResponse } from "@/types";

type Props = {
  page?: string;
  perPage?: string;
  search?: string;
};

async function fetchProcedures({
  search = "",
  page = "1",
}: Props): Promise<ProcedureResponse> {
  const response = await httpRequest.get<ProcedureResponse>(
    `/procedures?page=${page}&search=${search}`
  );
  return response.data;
}

export function useFetchProceduresQuery(props: Props) {
  const proceduresQuery = useQuery({
    queryKey: [
      "procedures",
      props.page || "1",
      props.perPage || "10",
      props.search,
    ],
    queryFn: () => fetchProcedures(props),
    keepPreviousData: true,
  });

  return {
    ...proceduresQuery,
    data: proceduresQuery.data,
  };
}
